// extracted by mini-css-extract-plugin
module.exports = {"html":"_91a14f3","body":"_09caad2","main":"_2ce2440","fixed":"_738637e","repeat":"_dc01ecf","center":"_af57069","start":"_65e17b4"};